module.exports = __webpack_public_path__ + "static/media/woman-working-on-a-laptop3.8417421d.jpg";